import {useEffect} from "react";
export default function Forgeviewer (props) {

    useEffect(() => {
        initialize(props.url);
        // Change title based on URL parameter 'design'
        const urlParams = new URLSearchParams(window.location.search);
        const design = urlParams.get('design');
        if (design) {
            document.title = `${design.replace('_', ' #')}`;
        }
    }, [props.url]);

    return (
        <div id="MyViewerDiv"/>
    );
}
function customizeToolbar(viewer) {
    // Get the toolbar
    var toolbar = viewer.getToolbar(true);

    // Get the 'modelTools' group
    var modelTools = toolbar.getControl("modelTools");

    // Hide the 'Explode' button
    if (modelTools) {
        var explodeButton = modelTools.getControl("explodedIsolate");
        if (explodeButton) {
            explodeButton.setVisible(false);
        }
    }

    // You can continue this way to hide other buttons
}
function initialize(url)
{
    const viewerDiv= document.getElementById("MyViewerDiv");
    const viewer = new Autodesk.Viewing.GuiViewer3D(viewerDiv);

    var options = {
        env: "Local",
    };

    Autodesk.Viewing.Initializer(options, async function onInitialized() {
        viewer.start();

        loadModel(viewer, url);

    });
}
function loadModel(viewer, url) {
    Autodesk.Viewing.Document.load(
        url,
        (doc) => {
            let viewables = doc.getRoot().getDefaultGeometry();
            viewer.loadDocumentNode(doc, viewables, {})
                .then(() => {
                    viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, function () {
                        const camera = viewer.getCamera();

                        // Set the camera position
                        camera.position.set(100, 100, 100);

                        // Set the camera target (where the camera is looking at)
                        camera.target.set(0, 0, 0);

                        // Set the camera's up vector
                        camera.up.set(0, 1, 0);

                        // Update the viewer to use the new camera settings
                        viewer.impl.invalidate(true, true, true);

                        // Optionally fit the view to the entire model
                        viewer.fitToView();
                    });
                });
        },
        (error) => {
            console.log(error);
            const viewerDiv = document.getElementById("MyViewerDiv");
            viewerDiv.innerHTML = "<h2>ID Not Found</h2>";
        }
    );
}


